export class CashPaymentOrder {
    public orderCode: string;
    public amount: number;
}

export class PaySafePayment {
    public cashPaymentOrders: CashPaymentOrder[];
    public orderCodes: string;
    public amount: number;
    public paySafeUrl: string;
    public paySafeMerchantID: string;
    public paySafePaymentID: string;
    public paySafeMerchantRefNum: string;
}
